export default __webpack_public_path__ + "static/logo_v2-758f1727f43f38cd8561375bf12133b6.svg";